export const countryList = [
  {
    alpha2: "AT",
    name: "Austria"
  },
  {
    alpha2: "BE",
    name: "Belgium"
  },
  {
    alpha2: "CZ",
    name: "Czech Republic"
  },
  {
    alpha2: "DK",
    name: "Denmark"
  },
  {
    alpha2: "DE",
    name: "Germany"
  },
  {
    alpha2: "HU",
    name: "Hungary"
  },
  {
    alpha2: "IE",
    name: "Ireland"
  },
  {
    alpha2: "LU",
    name: "Luxembourg"
  },
  {
    alpha2: "NL",
    name: "Netherlands"
  },
  {
    alpha2: "PL",
    name: "Poland"
  },
  {
    alpha2: "PT",
    name: "Portugal"
  },
  {
    alpha2: "SK",
    name: "Slovakia"
  },
  {
    alpha2: "SI",
    name: "Slovenia"
  },
  {
    alpha2: "ES",
    name: "Spain"
  },
  {
    alpha2: "GB",
    name: "United Kingdom"
  },
  {
    alpha2: "FI",
    name: "Finland"
  },
  {
    alpha2: "HR",
    name: "Croatia"
  },
  {
    alpha2: "FR",
    name: "France"
  },
  {
    alpha2: "IT",
    name: "Italy"
  }
]



// WEBPACK FOOTER //
// ./static/countries.js